import { Link } from "react-router-dom";
import RoleNav from "./RoleNav";
import logo from "../images/e_logo.png";

const Header = () => {
  return (
    <header className="header-shadow sticky-top bg-white">
      <nav className="navbar navbar-expand-lg navbar-light py-2">
        <div className="container-fluid">
          {/* Brand */}
          <Link to="/" className="navbar-brand d-flex align-items-center">
            <img
              src={logo}
              width="52"
              height="52"
              className="d-inline-Cinzel align-top me-2"
              alt="Logo"
              style={{ borderRadius: "8px" }}
            />
            <div className="d-flex flex-column">
              <span className="brand-text fw-bold">
                GOLDEN <span className="">HIDES</span>
              </span>
              <small className="brand-subtext">
                
              </small>
            </div>
          </Link>

          {/* Toggler */}
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Right side (dynamic nav based on role) */}
          <div
            className="collapse navbar-collapse justify-content-end"
            id="navbarSupportedContent"
          >
            <RoleNav />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
